/**
 * @file 默认语言和法币单位
 */
import { isClient } from '@vueuse/shared';
import { useCommonStore } from '@/store/common';
import { useConfigStore } from '@/store/config';
import { setLang, supportLang, getLanguageISO, getRouteLangPath, getOriginPath } from '@/lang/i18n';
import { defaultLang, defaultLegalFlag } from '@/config/setup';
import { supportLanguagesMap } from '@/config/site';
import { setCookie } from '@/utils/cookie';

export default () => {
  const route = useRoute();
  const commonStore = useCommonStore();
  const configStore = useConfigStore();

  const langPath = route.path.split('/')[1];
  const langPathISO = supportLang(langPath) ? getLanguageISO(langPath) : defaultLang;

  // 专属活动相关页面
  const exclusiveActivitiesPaths = [
    '/affiliates/exclusive-activities', 
    'register/active',
    'register/persian'
  ];

  /**
   * 设置页面语言
   *
   * @param languages 管理后台配置数据
   */
  const setDefaultLang = async(languages: Array<any>) => {
    const [routeLangItem] = languages.filter((item: any) => item.language === langPathISO.toLowerCase());
    const lang = routeLangItem?.language || languages[0].language;
    const activeLang = `${lang.split('-')[0]}-${lang.split('-')[1].toUpperCase()}`;
    if (isClient) {
      localStorage.setItem('lang', activeLang);
      setCookie('c_lang', activeLang);
      setLang(activeLang, activeLang !== langPathISO);
      commonStore.lang = activeLang;
    }
  };

  if (!exclusiveActivitiesPaths.some(path => getOriginPath(route.path).includes(path))) {
    watch(() => configStore.supportLanguages, languages => {
      if (languages.length) {
        setDefaultLang(languages);
      }
    }, { immediate: true });
  }

  watch(() => configStore.supportLegalCurrency, legalCurrency => {
    // 法币默认值
    if (legalCurrency.length) {
      const localeCurreny = defaultLegalFlag();
      const [localeCurrenyItem] = legalCurrency.filter((item: any) => item.currency === localeCurreny);
      const currency = localeCurrenyItem?.currency || legalCurrency[0].currency;
      commonStore.suffix = currency;
      commonStore.prefix = localeCurrenyItem?.currencyLabel || legalCurrency[0].currencyLabel;
      isClient && localStorage.setItem('legal_flag', currency);
    }
  }, { immediate: true });
};
